export enum FinancingServiceOrganizationSettingSource {
    diagnosticReport = 'diagnosticReport',
    procedure = 'procedure',
}
